import {
  Flex,
  Icon,
  PlacementWithLogical,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { FaTimesCircle } from "react-icons/fa";
import type { ProjectDocument } from "~/core/types";
import RequiredIndicator from "../RequiredIndicator";

export default function MinFollowerOnTwitterRequirement({
  project,
  isTooltipOpen,
  tooltipPosition,
}: {
  project: ProjectDocument;
  isTooltipOpen: boolean;
  tooltipPosition?: PlacementWithLogical;
}) {
  return project?.twitter?.enabled &&
    project?.twitter?.isMinFollowersRequired ? (
    <Tooltip
      label={
        <>
          You must have at lease{" "}
          <b>{project?.twitter?.minFollowers} follower(s)</b> on Twitter
        </>
      }
      pointerEvents={"all"}
      isOpen={isTooltipOpen}
      padding={4}
      fontSize={"md"}
      backgroundColor={"red.500"}
      placement={tooltipPosition}
      hasArrow
    >
      <Flex direction="row" alignItems="center" mb={2}>
        <Text fontSize="13" color={"descText"}>
          Have at least <b>{project?.twitter?.minFollowers} follower(s)</b> on
          Twitter{" "}
          {isTooltipOpen && (
            <Text as={"span"}>
              <Icon as={FaTimesCircle} color="#CD4A38" />
            </Text>
          )}
        </Text>
        <RequiredIndicator required={!project.twitter.isMinFollowersOptional} />
      </Flex>
    </Tooltip>
  ) : null;
}
